import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import SocialShare from 'components/_molecules/SocialShare'
import { socialConfiguration, } from 'core'
import './styles.css'

const localhostDomain = new RegExp(/http[s]?:\/\/localhost(:\d+)?/, 'i')
function getShareUrl(url) {
  if (url.match(localhostDomain)) {
    return url.replace(localhostDomain, socialConfiguration.defaultDomain)
  }
  return url
}

class ShareTrip extends Component {

  static propTypes = {
    tripName: PropTypes.string,
    eventName: PropTypes.string,
  }

  static defaultProps = {
    tripName: '',
    eventName: '',
  }

  render() {
    const {
      tripName,
      eventName,
    } = this.props

    return (
      <div className="ShareTrip">
        {tripName ? (
          <div>
            <h4> Share Trip </h4>
            <p>{tripName}{eventName && `, ${eventName}`}</p>
          </div>
        ) : (
          <div>
            <h4> Share Tourplanr </h4>
          </div>
        )}
        <SocialShare
          title={socialConfiguration.shareTitle}
          description={eventName || tripName}
          url={getShareUrl(window.location.href)}
          hashtags={socialConfiguration.hashtags}
        />
      </div>
    )
  }
}

export default ShareTrip



// WEBPACK FOOTER //
// ./src/components/ShareTrip/component.js